export default "__VITE_ASSET__BydGjdBZ__"